module.exports = __webpack_public_path__ + "img/analysis-results-update-desktop-en.02f65aa4.jpg";